var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchaseReceiving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 5,
    fill: "#009AD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 43L20.5 40H31L29.8 37H20L18.5 34H34.1L32.9 31H18.22L16.5 28H24C24 26.9391 24.4214 25.9217 25.1716 25.1716C25.9217 24.4214 26.9391 24 28 24H52V32H58L64 40V50H60C60 51.5913 59.3679 53.1174 58.2426 54.2426C57.1174 55.3679 55.5913 56 54 56C52.4087 56 50.8826 55.3679 49.7574 54.2426C48.6321 53.1174 48 51.5913 48 50H40C40 51.5913 39.3679 53.1174 38.2426 54.2426C37.1174 55.3679 35.5913 56 34 56C32.4087 56 30.8826 55.3679 29.7574 54.2426C28.6321 53.1174 28 51.5913 28 50H24V43H22ZM54 53C54.7957 53 55.5587 52.6839 56.1213 52.1213C56.6839 51.5587 57 50.7956 57 50C57 49.2044 56.6839 48.4413 56.1213 47.8787C55.5587 47.3161 54.7957 47 54 47C53.2043 47 52.4413 47.3161 51.8787 47.8787C51.3161 48.4413 51 49.2044 51 50C51 50.7956 51.3161 51.5587 51.8787 52.1213C52.4413 52.6839 53.2043 53 54 53ZM57 35H52V40H60.92L57 35ZM34 53C34.7956 53 35.5587 52.6839 36.1213 52.1213C36.6839 51.5587 37 50.7956 37 50C37 49.2044 36.6839 48.4413 36.1213 47.8787C35.5587 47.3161 34.7956 47 34 47C33.2044 47 32.4413 47.3161 31.8787 47.8787C31.3161 48.4413 31 49.2044 31 50C31 50.7956 31.3161 51.5587 31.8787 52.1213C32.4413 52.6839 33.2044 53 34 53Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseReceiving);
export default __webpack_public_path__ + "static/media/purchase-receiving.63598620.svg";
export { ForwardRef as ReactComponent };